import { css } from 'emotion'

export const displayBlockStyles = css`
  display: block;
`
